import { useQuery } from '@tanstack/react-query';

import { fetchPhotoSessionDetail } from 'api/photo-session';
import { PhotoSessionDetail } from 'models/PhotoSessionDetail';

export const getKey = photoSessionId => [
  'photo-session',
  Number(photoSessionId),
];

const usePhotoSession = (photoSessionId, options) =>
  useQuery({
    queryKey: getKey(photoSessionId),
    queryFn: () => fetchPhotoSessionDetail(photoSessionId),
    enabled: !!photoSessionId,
    select: data => new PhotoSessionDetail(data.job),
    ...options,
  });

export default usePhotoSession;
